import React, { useContext } from 'react';

import Icon from '../kingpin/atoms/Icon';
import Tooltip from './Tooltip';
import Typography from 'kingpin/atoms/Typography';
import ReportGadgetContext from '../contexts/ReportGadgetContext';
import reportGadgetHasCustomFilters from '../utils/reportGadgetHasCustomFilters';

const CanvasCardTitle = ({ title }: { title: string }) => {
  const reportGadgetContext = useContext(ReportGadgetContext);
  const reportGadget = reportGadgetContext?.reportGadget;
  const hasCustomFilters =
    reportGadget && reportGadgetHasCustomFilters(reportGadget);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      <Typography.Header type="H6" isEllipsis>
        {title}
      </Typography.Header>
      {hasCustomFilters && (
        <Tooltip content="This gadget has custom filters" position="top">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Icon icon="filters" />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default CanvasCardTitle;
